import { createContext, useContext } from 'react';

const KBContext = createContext(null);

export const useKB = () => {
  const ctx = useContext(KBContext);
  if (!ctx) throw new Error('useKB must be used within KBProvider');
  return ctx;
};

export default KBContext;
